export interface GenericClass {
  permissionObj: { [key: string]: string };
  setCookie: (name: string, value: string, days: number) => void;
  getCookie: (name: string) => string | null;
  deleteCookie: (name: string) => void;
}

export class GenericClassImpl implements GenericClass {
  permissionObj: { [key: string]: string } = {
    isPermissionForJobsViewEnabled: 'overzichten vacatures',
    isPermissionForApplicantsEnabled: 'kandidaten',
    isPermissionForPublicationsEnabled: 'publicaties',
    isPermissionForCandidateEnabled: 'kandidaten',
    isPermissionForReviewsEnabled: 'reviews',
    isPermissionForMultipostingEnabled: 'multiposting',
    isPermissionForContactEnabled: 'contact',
    isTemplateManagementEnabled: 'TemplateManagement',
    isAgentInstructionEnabled: 'AgentInstructionConfiguration',
  };

  setCookie(name: string, value: string, days: number): void {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
  }

  getCookie(name: string): string | null {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return parts.pop()?.split(';').shift() || null;
    }
    return null;
  }

  deleteCookie(name: string): void {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
  }
}

// Export singleton instance
export const GenericClass = new GenericClassImpl();
